
import React from 'react';
import { Link } from 'react-router-dom';
import { X, Phone, Mail, MapPin, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import SocialLinks from './SocialLinks';
import { motion, AnimatePresence } from 'framer-motion';
import { SITE } from '@/data/site';
import { trackPhoneClick } from '@/lib/analytics';

function MobileMenu({ isOpen, onClose }) {
  const navItems = [
    { label: 'Головна', path: '/' },
    { label: 'Послуги', path: '/services' },
    { label: 'Відгуки', path: '/reviews' },
    { label: 'Контакти', path: '/contacts' }
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-black/50 z-40"
            onClick={onClose}
          />
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
            className="fixed top-0 right-0 bottom-0 w-full max-w-sm bg-[#1a1a1a] text-white z-50 overflow-y-auto"
          >
            <div className="p-6">
              <div className="flex justify-between items-center mb-8">
                <span className="text-xl font-bold">Меню</span>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={onClose}
                  className="text-white hover:bg-white/10"
                >
                  <X className="w-6 h-6" />
                </Button>
              </div>

              <nav className="space-y-1 mb-8">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={onClose}
                    className="block px-4 py-3 rounded-lg hover:bg-white/10 transition-all duration-200 font-medium"
                  >
                    {item.label}
                  </Link>
                ))}
              </nav>

              <div className="border-t border-white/10 pt-6 space-y-4">
                <h3 className="font-semibold text-lg mb-4">Контакти</h3>
                
                <div className="space-y-3">
                  <a
                    href={`tel:${SITE.phoneE164Primary}`}
                    className="flex items-start gap-3 hover:text-primary transition-colors"
                    onClick={() => trackPhoneClick(SITE.phoneE164Primary)}
                  >
                    <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                    <div className="text-sm">
                      <div>{SITE.phonePrimary}</div>
                      <div>{SITE.phoneSecondary}</div>
                    </div>
                  </a>

                  <a href={`mailto:${SITE.email}`} className="flex items-start gap-3 hover:text-primary transition-colors">
                    <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" />
                    <span className="text-sm">{SITE.email}</span>
                  </a>

                  <div className="flex items-start gap-3">
                    <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                    <span className="text-sm">м. Київ, вул. Марка Черемшини, 38а</span>
                  </div>

                  <div className="flex items-start gap-3">
                    <Clock className="w-5 h-5 mt-0.5 flex-shrink-0" />
                    <div className="text-sm">
                      <div>Пн–Пт: 08:00–20:00</div>
                      <div>Сб–Нд: 09:00–18:00</div>
                    </div>
                  </div>
                </div>

                <div className="pt-4">
                  <p className="text-sm mb-3">Зв'яжіться з нами:</p>
                  <SocialLinks variant="outline" size="default" />
                </div>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}

export default MobileMenu;
